export const DEFAULT_CHANNEL = {
  platform: ['8', '8'],
  comboChannel: ['109', '2'],
};

/*
 * 所有渠道配置
 *
 * 参数含义：
 * - platform: 平台码，数组第一个标识ios，第二个标识安卓，第三个标识鸿蒙
 * - comboChannel: 投放平台码，数组第一个标识淘票票域名，第二个标识大麦域名
 * 更多信息请参考: https://yuque.antfin-inc.com/tppwd/tech/platforms
 */
export const froms = {
  /** 浏览器 */
  def: {
    name: 'def',
    ...DEFAULT_CHANNEL,
  },
  /** 浏览器 */
  outer: {
    name: 'outer',
    ...DEFAULT_CHANNEL,
  },
  /** 中国移动 */
  cmcc: {
    name: 'cmcc',
    platform: ['95', '95'],
  },

  /** 抖音 */
  douyin: {
    name: 'douyin',
    platform: ['101', '101'],
    comboChannel: ['107'],
  },
  /**
   * 阿里云OS
   */
  yos: {
    name: 'yos',
    platform: ['1024', '1024'],
  },
  /**
   * 手淘本地生活 264鸿蒙
   */
  nearby: {
    name: 'nearby',
    platform: ['4096', '2048', '264'],
    comboChannel: ['103'],
  },
  /**
   * 高德
   */
  gaode: {
    name: 'gaode',
    platform: ['262144', '524288'],
    comboChannel: ['106'],
  },
  /**
   * UC浏览器
   */
  uc: {
    name: 'uc',
    platform: ['2097152', '4194304'],
  },
  /**
   * 新浪微博
   */
  weibo: {
    name: 'weibo',
    platform: ['16384', '8192'],
  },
  /**
   * 新浪微博小程序
   */
  weiboapp: {
    name: 'weiboapp',
    platform: ['232', '232'],
    comboChannel: ['119'],
  },
  /**
   * 喵街
   */
  mj: {
    name: 'mj',
    platform: ['16777216', '16777216'],
  },
  /**
   * 喵街
   */
  miaojie: {
    name: 'miaojie',
    platform: ['16777216', '16777216'],
  },
  /**
   * 人工智能语音助手
   */
  wulin: {
    name: 'wulin',
    platform: ['8388608', '8388608'],
  },
  /**
   * 神马搜索
   */
  shenma: {
    name: 'shenma',
    platform: ['33554432', '33554432'],
  },
  /**
   * 手淘娱乐
   */
  yule: {
    name: 'yule',
    platform: ['67108864', '67108864'],
  },
  /**
   * 娱乐宝
   */
  yulebao: {
    name: 'yulebao',
    platform: ['268435456', '268435456'],
  },
  /** 影客，淘票票APP */
  tbmovie: {
    name: 'tbmovie',
    platform: ['2', '4', '215'],
    comboChannel: ['101'],
  },
  /** 淘票票专业版 */
  tpppro: {
    name: 'tpppro',
    platform: ['38', '38'],
  },
  /**
   * 58同城
   */
  '58tc': {
    name: '58tc',
    platform: ['16', '16'],
  },
  /**
   * 中华万年历
   */
  zhwnl: {
    name: 'zhwnl',
    platform: ['32', '32'],
  },
  /**
   * 支付宝
   */
  alipay: {
    name: 'alipay',
    platform: ['32768', '65536'],
    comboChannel: ['102'],
  },
  /**
   * 支付宝本地生活
   */
  aparhat: {
    name: 'aparhat',
    platform: ['167', '168', '265'],
    comboChannel: ['102'],
  },
  /**
   * 手淘猜你喜欢
   */
  tbguess: {
    name: 'tbguess',
    platform: ['4096', '2048'],
  },
  /**
   * 大麦App
   */
  damai: {
    name: 'damai',
    platform: ['204', '204'],
    comboChannel: ['198', '1'],
  },
  /**
   * 优酷
   */
  youku: {
    name: 'youku',
    platform: ['64', '64'],
  },
  /**
   * 酷派
   */
  kupai: {
    name: 'kupai',
    platform: ['128', '128'],
  },
  /**
   * 口碑APP
   */
  koubei: {
    name: 'koubei',
    platform: ['131072', '131072'],
    comboChannel: ['105'],
  },
  /**
   * 支付宝口碑
   */
  apkoubei: {
    name: 'apkoubei',
    platform: ['76', '77'],
    comboChannel: ['105'],
  },
  /**
   * 华为内置口碑app
   */
  koubeihuawei: {
    name: 'koubeihuawei',
    platform: ['46', '46'],
    comboChannel: ['105'],
  },
  /**
   * 百度小程序
   */
  baiduApp: {
    name: 'baiduApp',
    platform: ['97', '97'],
    comboChannel: ['110'],
  },
  /**
   * 爱奇艺小程序
   */
  iQiYiMiniProgram: {
    name: 'iQiYiMiniProgram',
    platform: ['242', '242'],
  },
  /** 猫客 */
  tmall: {
    name: 'tmall',
    platform: ['5', '5'],
  },
  /**
   * 淘金币
   */
  taojinbi: {
    name: 'taojinbi',
    platform: ['13', '13'],
  },
  /**
   * 惠支付
   */
  huipay: {
    name: 'huipay',
    platform: ['33', '33'],
  },
  /**
   * 三星生活助手
   */
  samsung: {
    name: 'samsung',
    platform: ['7', '7'],
  },
  /**
   * 海信电视
   */
  hisensetv: {
    name: 'hisensetv',
    platform: ['72', '72'],
  },
  /**
   * 微信
   */
  wechat: {
    name: 'wechat',
    platform: ['42', '42'],
    comboChannel: ['108', '4'],
  },
  /** 淘好票影城微信小程序 */
  wechatm: {
    name: 'wechatm',
    platform: ['147', '147'],
  },
  /**
   * 恒大嘉凯影城小程序
   */
  jiakaim: {
    name: 'jiakaim',
    platform: ['172', '172'],
  },
  /**
   * 武商摩尔影城小程序
   */
  moerm: {
    name: 'moerm',
    platform: ['230', '230'],
  },
  /**
   * 星空影城小程序
   */
  xingkongm: {
    name: 'xingkongm',
    platform: ['231', '231'],
  },
  /**
   * quickapp 命中了关键字，导致快应用跳转 h5 报错
   */
  quickapp1: {
    name: 'quickapp1',
    platform: ['78', '78'],
  },
  /**
   * 快应用 oppo 渠道
   */
  quickappoppo: {
    name: 'quickappoppo',
    platform: ['103', '103'],
  },
  /**
   * 快应用 vivo 渠道
   */
  quickappvivo: {
    name: 'quickappvivo',
    platform: ['106', '106'],
  },
  /**
   * 快应用 xiaomi 渠道
   */
  quickappxiaomi: {
    name: 'quickappxiaomi',
    platform: ['110', '110'],
  },
  /**
   * 快应用 zte 渠道
   */
  quickappzte: {
    name: 'quickappzte',
    platform: ['111', '111'],
  },
  /**
   * 快应用 gionee 渠道
   */
  quickappgionee: {
    name: 'quickappgionee',
    platform: ['112', '112'],
  },
  /**
   * 快应用 lenovo 渠道
   */
  quickapplenovo: {
    name: 'quickapplenovo',
    platform: ['113', '113'],
  },
  /**
   * 快应用 meizu 渠道
   */
  quickappmeizu: {
    name: 'quickappmeizu',
    platform: ['114', '114'],
  },
  /**
   * 快应用 nubia 渠道
   */
  quickappnubia: {
    name: 'quickappnubia',
    platform: ['115', '115'],
  },
  /**
   * 快应用 huawei 渠道
   */
  quickapphuawei: {
    name: 'quickapphuawei',
    platform: ['117', '117'],
  },
  /**
   * 头条
   */
  toutiao: {
    name: 'toutiao',
    platform: ['91', '91'],
  },
  /**
   * 阿里妈妈淘客联盟
   */
  alimamatk: {
    name: 'alimamatk',
    platform: ['118', '118'],
  },
  /**
   * 一淘app
   */
  etao: {
    name: 'etao',
    platform: ['119', '119'],
  },
  /**
   * 强国app
   */
  qiangguo: {
    name: 'qiangguo',
    platform: ['151', '151'],
  },
  /**
   * 饿了么
   */
  eleme: {
    name: 'eleme',
    platform: ['80', '80'],
    comboChannel: ['104'],
  },
  /**
   * 支付宝影城小程序
   */
  mtheater: {
    name: 'mtheater',
    platform: ['183', '183'],
  },
  /**
   * 快手
   */
  kuaishou: {
    name: 'kuaishou',
    platform: ['193', '193'],
    comboChannel: ['111'],
  },
  /**
   * MPAAS邮储银行
   */
  psbbank: {
    name: 'psbbank',
    platform: ['195', '195'],
  },
  /**
   * 鸿蒙淘票票531版
   */
  msdy: {
    name: 'msdy',
    platform: ['2', '4', '8'],
  },
  /**
   * 鸿蒙大麦531版
   */
  msdm: {
    name: 'msdm',
    platform: ['204', '204', '8'],
  },
  /**
   * 小红书小程序
   */
  xhsminiprogram: {
    name: 'xhsminiprogram',
    platform: ['266', '266'],
    comboChannel: ['120', '2'],
  },
} as const;
